import { Inject } from '@angular/core';
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { HttpClient } from '@angular/common/http';
import { APIS } from "src/app/apis";
import { NAVIGATION_ROUTES } from "src/app/navigation-routes.const";
import { LocalStorageKeys } from "src/app/moov-common/services/localStorage/local-storage.enum";
import { DOCUMENT } from '@angular/common';
import { BaseComponent } from 'src/app/moov-common/base/base.component';
import { TranslateService } from '@ngx-translate/core';
import { AbstractLocalStorageService } from 'src/app/moov-common/services/localStorage/local-storage.abstract.service';
import { AbstractAuthorizationService } from 'src/app/moov-common/services/authorization/authorization.abstract.service';
import { AbstractPersonalUserDataService } from 'src/app/moov-common/services/personal-user-data/personal-user-data.abstract.service';
import { AccountTypeEnum, DiscoveryStatusEnum, UserRole } from 'src/app/moov-common/services/personal-user-data/personal-user-data';
import { InternalEventsManagerService } from 'src/app/moov-common/services/internal-events-manager/internal-events-manager.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent extends BaseComponent implements OnInit {
  isLogin: boolean = false;
  errorMessage: any;
  loginUrl = `${APIS.auth}/login`;
  token: string;
  imageRootFolder = "assets/common/";
  userMail: string = "";
  password: string = "";
  resetPasswordUserMail: string = "";
  hidePassword: boolean = true;
  lastLoginFailedOnCreds: boolean = false;
  lastLoginFailedGeneral: boolean = false;
  isForgotPasswordView:boolean = false;
  passwordResetRequestWasSent: boolean = false;

  constructor(@Inject(DOCUMENT) private document: Document,
    private localStorageService: AbstractLocalStorageService,
    private authorizationService: AbstractAuthorizationService,
    private router: Router, private http: HttpClient,
    private personalUserDataService: AbstractPersonalUserDataService,
    private internalEventService: InternalEventsManagerService,
    private translate: TranslateService
  ) {
    super();
    
   }

  ngOnInit(): void {
    super.ngOnInit();
    this.hidePassword = true;
    this.lastLoginFailedOnCreds = false;
    this.lastLoginFailedGeneral = false;
    this.checkLoggedInOrInDiscovery();
  }

  async submit() {

    // clear local storage leftovers 
    this.localStorageService.clear(LocalStorageKeys.teamViewFilterBYManager);
    this.localStorageService.clear(LocalStorageKeys.moovToken);
    this.localStorageService.clear(LocalStorageKeys.userPersonalInfo);

    this.authorizationService.getMoovToken(this.userMail, this.password).subscribe(response => {
      if (response.status === 200 && (response.body)) {
        this.lastLoginFailedOnCreds = false;
        this.lastLoginFailedGeneral = false;
        const result = response.body;
        this.token = result.token;
        this.localStorageService.write<string>(LocalStorageKeys.moovToken, this.token);
        this.authorizationService.saveUserDetailsLocally(this.token);
        this.personalUserDataService.setLocale("");
        this.localStorageService.write<string>(LocalStorageKeys.userSelectedLocale, this.personalUserDataService.getUserLocale());
        this.internalEventService.reloadUserData.emit("");
        this.internalEventService.userLoggedIn.emit();
        this.analytics.loginEvent();
        this.redirectToOriginalUrl();
      } else {
        if (response.status === 401) {
          this.lastLoginFailedOnCreds = true;
        } else {
          this.lastLoginFailedGeneral = true;
        }
      }
    }, error => {
        if (error.status === 401) {
          this.lastLoginFailedOnCreds = true;
        } else {
          this.lastLoginFailedGeneral = true;
        }
    })
  }

  forgotPasswordSubmit(){

    console.log(`in login forgot password submit`);

    this.personalUserDataService.resetUserPassword(this.resetPasswordUserMail).subscribe(res => {
      console.log(`in login forgot password submit - subsribe`);
      this.isForgotPasswordView = false;
      this.passwordResetRequestWasSent = true;
    });
  }

  isUserLogin() {
    return this.user ? true : false;
  }

  checkLoggedInOrInDiscovery() {
    if (this.isUserLogin()) {
       
      this.redirectToOriginalUrl();
    }
  }


  private redirectToOriginalUrl() {
    let redirectTo = "";
      try {
        let returnUrl = this.localStorageService.get<string>(LocalStorageKeys.returnUrl);

        if (!returnUrl || /*returnUrl === "" ||*/ returnUrl == NAVIGATION_ROUTES.login) {
          redirectTo = this.getUserHomePage();
        } else {
          redirectTo = returnUrl;
        }
      } catch (e) {
        redirectTo = this.getUserHomePage();
      }
      
      if (this.user?.accountType !== AccountTypeEnum.CAREER_INDEPENDENT && this.user?.accountType !== AccountTypeEnum.CAREER_INDEPENDENT_US && this.user?.discoveryStatus !== DiscoveryStatusEnum.DONE){
        // user have yet to finish the discovery process - redirect to first login page
        redirectTo = NAVIGATION_ROUTES.app.firstTimeLogin;
      }

      // remove redirection after login
      this.localStorageService.clear(LocalStorageKeys.returnUrl);

      // check if we are navigating and have query params
      if (redirectTo.includes('?')){
        let redirectTo_Raw = redirectTo.substring(0, redirectTo.indexOf('?'));
        // as we are in a critical navigation part, and handling non predicted url, we don't want to fail on parsing errors, if something fails, just go to redirectTo_Raw (stripping query params) 
        try{        
          // allQueryParams_Raw looks like this now 'param_1=val_1&param_2=val_2&param_3=val_3'
          let allQueryParams_Raw = redirectTo.substring(redirectTo.indexOf('?') + 1);
          
          let queryParams = allQueryParams_Raw.split('&');
          
          let queryParamsList : JSON = JSON.parse('{}');

          for (let currQueryParam of queryParams){
            // now we have pairs, each currQueryParam looks like 'param_x=val_x'
            let currQueryParamsPairList : string[] = currQueryParam.split('=');
            let currQueryParamsPair = {[currQueryParamsPairList[0]]: currQueryParamsPairList[1]};

            queryParamsList= Object.assign(queryParamsList, currQueryParamsPair);
          }
          
          this.router.navigate([redirectTo_Raw], {queryParams: queryParamsList});
        }
        catch(e){
          let errorMessage = '';
          if (typeof e === "string") {
              errorMessage = e;
          } else if (e instanceof Error) {
              errorMessage = e.message 
          }
          console.log(`in login, error while parsing query params, error is ${errorMessage} redirecting to ${redirectTo_Raw}`);
          this.router.navigate([redirectTo_Raw]);
      }
      }
      else{
        this.router.navigate([redirectTo]);  
      }  
  }

  getUserHomePage():string{
    if (this.user?.role == UserRole.EMPLOYEE){
      return NAVIGATION_ROUTES.app.personalView;
    }
    else{
      return NAVIGATION_ROUTES.app.teamView;
    }
  }

  forgotPassword(){
    this.isForgotPasswordView = true;
  }

  registerNewUser(){
    this.router.navigate([NAVIGATION_ROUTES.tokenLogin]);
  }
}

